import '../styles/App.css';
import { BrowserRouter, Routes } from "react-router-dom";
import {Invite} from './Invite';
import {Statistics} from './Statistics';
import { RouteKeys } from '../config/RouteKeys';
import { useAuthorization } from '../hooks/useAuthorization';
import { UnauthorizedContainer } from './UnauthorizedContainer';
import { LoadingContainer } from './LoadingContainer';

const App = () => {
  const {
    authorizedGuest,
    isGuestEntitledToRoute,
  } = useAuthorization(<UnauthorizedContainer/>);

  if (authorizedGuest !== undefined) {
    return (
      <BrowserRouter>
        <Routes>
          {isGuestEntitledToRoute(authorizedGuest, RouteKeys.INVITE, <Invite authorizedGuest={authorizedGuest}/>)}
          {isGuestEntitledToRoute(authorizedGuest, RouteKeys.STATISTICS, <Statistics/>)}
        </Routes>
      </BrowserRouter>
    );
  } else {
    return (
      <LoadingContainer/>
    );
  }
}

export default App;